<template>
  <div v-loading="p_loading" style="padding: 20px; min-height: 600px;overflow-y: auto;height: 100%;">
    <el-card v-if="!p_loading">
      <div v-if="ruleForm.register_from!='weimob'" class="title">
        <div @click="goback">
          <i class="el-icon-back" style="font-weight: bold; margin-right: 10px"></i>
          新建店铺
        </div>
      </div>
      <el-form :model="ruleForm" :rules="rules" style="width: 100%" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div style="font-size: 14px; color: black; font-weight: bold; margin-bottom: 10px">基本信息</div>
        <el-form-item label="品牌名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入品牌名称" size="small" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="店铺简介" prop="desc">
          <el-input v-model="ruleForm.desc" placeholder="请输入店铺简介" size="small" maxlength="250" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="ruleForm.mobile" placeholder="请输入联系电话" size="small"></el-input>
        </el-form-item>
        <el-form-item label="品牌logo" prop="logo">
          <el-upload
            action
            ref="uploadAdd"
            class="avatar-uploader"
            list-type="picture-card"
            :http-request="handleUpload.bind(this)"
            :show-file-list="false"
            accept="image/jpeg, image/png, image/jpg"
          >
            <el-image v-if="ruleForm.logo" :src="ruleForm.logo" class="avatar" fit="cover"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 12px; color: darkgray">最多1张图片，建议尺寸100*100像素,大小2M以下，jpg、jpeg、png格式</div>
        </el-form-item>
        <el-form-item label="品牌图片" prop="brand_logo">
          <el-upload
            :limit="10"
            action
            :multiple="true"
            ref="uploadAdd"
            :file-list="fileList"
            class="avatar-uploader"
            list-type="picture-card"
            :show-file-list="true"
            :before-upload="beforeUpload"

            :on-remove="onRemove"

            accept="image/jpeg, image/png, image/jpg"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div style="font-size: 12px; color: darkgray">最多10张图片，建议尺寸100*100像素，jpg、jpeg、png格式</div>
        </el-form-item>
        <!--        <el-form-item label="是否海外商户" prop="is_overseas">-->
        <!--          <el-radio-group v-model="ruleForm.is_overseas" size="small">-->
        <!--            <el-radio :label="0">否</el-radio>-->
        <!--            <el-radio :label="1">是</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <el-form-item label="经营类目" prop="category">
          <el-cascader placeholder="请选择经营类目" filterable style="width: 100%" :props="cateProps" :options="categoriesData" class="full-width" v-model="ruleForm.category" />
        </el-form-item>
        <el-form-item label="地区:" prop="address_code_array">
          <el-cascader placeholder="省/市/区" style="width: 100%" :options="areaSelectData" @change="handleChange" class="full-width" v-model="ruleForm.address_code_array" />
        </el-form-item>
        <div style="font-size: 14px; color: black; font-weight: bold; margin-bottom: 10px">运营人信息</div>
        <el-form-item label="姓名" prop="operate_name">
          <el-input v-model="ruleForm.operate_name" placeholder="请输入您的姓名" size="small"></el-input>
        </el-form-item>
        <div style="display: flex;align-items: center;">
          <el-form-item prop="operate_mobile" style="width: 50%;">
            <span slot="label">
              联系电话
              <el-tooltip class="item" effect="dark" content="运营号码为唯一店铺供销手机号,绑定后不可变更" placement="top-start">
                <i class="el-icon-info" style="cursor: pointer;"></i>
              </el-tooltip>
             </span>
            <el-input v-model="ruleForm.operate_mobile" placeholder="请输入您的联系电话" size="small"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="operate_mobile_code" style="width: 50%;">
            <el-input placeholder="请输入验证码" v-model="ruleForm.operate_mobile_code" style="margin-top: 3px;" size="small">
              <el-button @click="getyanzhengma" slot="append" size="small">{{ yanzhengma }}{{ yanzhengma == '获取验证码' ? '' : 's后重试' }}</el-button>
            </el-input>
          </el-form-item>
        </div>
        <el-form-item label="QQ号" prop="operate_qq">
          <el-input v-model="ruleForm.operate_qq" placeholder="请输入您的QQ号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="微信号" prop="operate_wechat">
          <el-input v-model="ruleForm.operate_wechat" placeholder="请输入您的微信号" size="small"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="operate_email">
          <el-input v-model="ruleForm.operate_email" placeholder="请输入您的邮箱" size="small"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="sub_loading" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { regionData, codeToText } from 'element-china-area-data';
import qs from 'qs';
import smart from 'address-smart-parse';
export default {
  data() {
    return {
      p_loading: false,
      sub_loading: false,
      areaSelectData: regionData,
      fileList: [],
      yanzhengma: '获取验证码',
      registerType:null,
      registerKey:null,
      timer: null,
      ruleForm: {
        name: '',
        desc: '',
        shop_cate_id: '',
        mobile: '',
        logo: '',
        brand_logo: [],
        is_overseas: 0,
        category: [],
        address_code_array: [],
        address_array: [],
        operate_name: '',
        operate_mobile: '',
        operate_mobile_code:'',
        operate_qq: '',
        operate_wechat: '',
        operate_email: '',
        register_from:'system',
        auth_param:'',
        platform_user_id:''
      },
      categories: [],
      rules: {
        name: [
          {
            required: true,
            message: '请输入品牌名称',
            trigger: 'blur'
          }
        ],
        desc: [
          {
            required: true,
            message: '请输入店铺简介',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          }
        ],
        logo: [
          {
            required: true,
            message: '请上传品牌logo',
            trigger: ['blur', 'change']
          }
        ],
        category: [
          {
            required: true,
            message: '请选择经营类目',
            trigger: ['blur', 'change']
          }
        ],
        address_code_array: [
          {
            required: true,
            message: '请选择地区',
            trigger: ['blur', 'change']
          }
        ],
        operate_name: [
          {
            required: true,
            message: '请输入您的姓名',
            trigger: 'blur'
          }
        ],
        operate_mobile: [
          {
            required: true,
            message: '请输入联系电话',
            trigger: 'blur'
          }
        ],
        operate_mobile_code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        operate_wechat: [
          {
            required: true,
            message: '请输入您的微信号',
            trigger: 'blur'
          }
        ],
      },
      categoriesData: [],
      cateProps: {
        label: 'name',
        value: 'id',
        children: 'childLevel'
      },
      authParam:{
        code:null,
        state:null
      }
    };
  },
  created() {
    this.ruleForm.shop_cate_id = this.$route.query.type;
    if(this.$route.query.register_from&&this.$route.query.code&&this.$route.query.state){
      this.ruleForm.register_from=this.$route.query.register_from;
      this.ruleForm.platform_user_id=this.$route.query.platform_user_id;
      this.authParam.code=this.$route.query.code;
      this.authParam.state=this.$route.query.state;
      if(this.ruleForm.register_from=="weimob"){
        this.getPlatformShopInfo( this.authParam.code)
      }
    }else{
      //system
      this.ruleForm.register_from="system";
      if(this.$route.query.register_type=='alibaba'){
        this.registerType="alibaba";
        this.registerKey=this.$route.query.register_key
      }else{
        this.registerType=null;
      }
    }

    this.getCategories();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getPlatformShopInfo(code){
      this.$get(this.$api.getPlatformShopInfo+code).then(res=>{
        if(res.status==200&&res.data){

          this.ruleForm.name=res.data.name
          this.ruleForm.desc=res.data.desc
          // this.ruleForm.shop_cate_id=res.data.shop_cate_id
          this.ruleForm.mobile=res.data.mobile
          this.ruleForm.logo=res.data.logo
          let brand_logo=[];
          if(res.data.brand_logo){
            brand_logo=JSON.parse(res.data.brand_logo)
          }
          if(brand_logo.length>0){
            this.fileList=brand_logo.map((item,index)=>{
              return {
                uid:100000+index,
                url:item
              }
            })
          }

          this.ruleForm.brand_logo=brand_logo
          this.ruleForm.category=res.data.category
          this.ruleForm.address_code_array=res.data.address_code_array.split(",")
          this.ruleForm.address_array=res.data.address_array
          this.ruleForm.operate_name=res.data.operate_name
          this.ruleForm.operate_mobile=res.data.operate_mobile
          this.ruleForm.operate_qq=res.data.operate_qq
          this.ruleForm.operate_wechat=res.data.operate_wechat
          this.ruleForm.operate_email=res.data.operate_email

        }
      })
    },
    // 获取验证码
    getyanzhengma() {
      if (this.ruleForm.operate_mobile) {
        if (this.yanzhengma == '获取验证码') {
          this.$confirm('运营号码为唯一店铺供销手机号,绑定后不可变更', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            closeOnClickModal: false
          }).then(() => {

            this.$get(this.$api.sendOperateMobileCode, {
              operate_mobile: this.ruleForm.operate_mobile
            }).then(res => {
              if (res.status == 200) {
                this.yanzhengma = 59
                this.timer = setInterval(() => {
                  if (this.yanzhengma <= 0) {
                    this.yanzhengma = '获取验证码'
                    clearInterval(this.timer)
                  } else {
                    this.yanzhengma = this.yanzhengma - 1
                  }
                }, 1000)
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
              }
            })
          })
        }
      } else {
        this.$message.error('请输入联系电话');
      }
    },
    getCategories() {
      this.p_loading = true;
      this.$get(this.$api.getCategories).then((res) => {
        if (res.status == 200) {
          this.categoriesData = res.data;
        }
        this.p_loading = false;
      });
    },

    beforeUpload(file){

      const uploadFormData = new FormData();
      uploadFormData.append('file', file);
      this.$uploadImg(this.$api.upload_img, uploadFormData).then((res) => {
        if (res.status == 200) {

          this.fileList.push({
            uid:file.uid,
            url:res.data.url
          })

        }
      });
      return false

    },
    handleUploadMore(param) {
      const uploadFormData = new FormData();
      uploadFormData.append('file', param.file);

      this.$uploadImg(this.$api.upload_img, uploadFormData).then((res) => {
        if (res.status == 200) {

          // this.fileList.push(param.file.uid);
          this.fileList.push({
            url:res.data.url
          })

          //  this.ruleForm.brand_logo.push(res.data.url);
        }
      });


    },
    onRemove(file, fileList) {

      this.fileList=fileList
    },
    handleChange(value) {
      var name = [];
      value.forEach((item) => {
        name.push(codeToText[item]);
      });
      this.ruleForm.address_code_array = value;
      this.ruleForm.address_array = name;
    },
    handleUpload(param) {
      const uploadFormData = new FormData();
      uploadFormData.append('file', param.file);
      this.$uploadImg(this.$api.upload_img, uploadFormData).then((res) => {
        if (res.status == 200) {
          this.ruleForm.logo = res.data.url;
        }
      });
    },
    submitForm(formName) {
      const h = this.$createElement;
      if(this.authParam.code&&this.authParam.state){
        this.ruleForm.auth_param=encodeURI( qs.stringify(this.authParam))
      }


      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.brand_logo=[]

          this.ruleForm.brand_logo=this.fileList.map(item=>{
            return item.url
          })
          this.sub_loading = true;
          if(this.authParam.code&&this.authParam.state){
            this.ruleForm.auth_param= qs.stringify(this.authParam)
          }
          this.p_loading=true
          this.$post(this.$api.createShop, this.ruleForm).then((res) => {
            this.sub_loading = false;

            if (res.status == 200) {

              if(res.data.login_token){
                let msg=[];
                if(res.data.msg){
                  res.data.msg.forEach(item=>{
                    msg.push(  h('p', null, item))
                  })
                }
                if(msg.length>0){
                  this.$msgbox({
                    title: '消息',
                    message: h('p', null, msg),
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    closeOnHashChange:false,
                    confirmButtonText: '确定',
                  }).then(action => {
                    this.$router.push({
                      path: '/authWelcome',
                      query:{
                        key:res.data.login_token,
                        is_choose_identity:1
                        // msg:res.data.msg
                      }
                    });
                  });
                }else{
                  this.$router.push({
                    path: '/authWelcome',
                    query:{
                      key:res.data.login_token,
                      is_choose_identity:1
                      // msg:res.data.msg
                    }
                  });
                }



              }else {
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                if(this.registerType=="alibaba"){
                  this.$router.push({
                    path: '/alibabaAuth',
                    query:{
                      register_type:'alibaba',
                      register_key:this.registerKey,
                      // new_shop_id:res.data.shop.shop_id
                    }
                  });
                }else{
                  this.$router.push({
                    path: '/chooseStore'
                  });
                }
                // this.$refs[formName].resetFields();

              }

            }
          }).finally(()=>{
            this.p_loading=false
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 14px;
  color: #303133;
  font-weight: 600;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.title div {
  cursor: pointer;
}

.title div:hover {
  color: #409eff;
}

>>> .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

>>> .avatar-uploader-icon {
  width: 80px;
  height: 80px;
}

>>> .avatar-uploader-icon {
  line-height: 80px;
}

>>> .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/addStore/index.vue